import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-config/blade-config/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-config/blade-config/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-config/blade-config/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-config/blade-config/save',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-config/blade-config/update',
    method: 'post',
    data: row
  })
}

export const getActivaionInfo = () => {
  return request({
    url: '/api/blade-config/blade-config/getActivaionInfo',
    method: 'get',
    data: {}
  })
}



